import { render, staticRenderFns } from "./DialogDividerItem.vue?vue&type=template&id=2de6cae4&scoped=true"
import script from "./DialogDividerItem.vue?vue&type=script&lang=js"
export * from "./DialogDividerItem.vue?vue&type=script&lang=js"
import style0 from "./DialogDividerItem.vue?vue&type=style&index=0&id=2de6cae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de6cae4",
  null
  
)

export default component.exports